import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/lib/auth";
import LanguageSwitcher from "@/components/LanguageSwitcher";
import SiteFooter from "@/components/SiteFooter";

// Lightweight shell for static marketing / legal pages (About, Privacy, Terms).
export default function MarketingShell({ eyebrow, title, updated, children }) {
  const { t } = useTranslation();
  const { user } = useAuth();
  return (
    <div className="min-h-screen bg-bone text-obsidian flex flex-col" data-testid="marketing-shell">
      <nav className="sticky top-0 z-40 backdrop-blur-md bg-bone/85 border-b border-border">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <div className="w-3 h-3 bg-intl" />
            <span className="font-app font-bold tracking-tight text-base">AI Visibility OS</span>
          </Link>
          <div className="flex items-center gap-2">
            <LanguageSwitcher />
            {user ? (
              <Link to="/dashboard" className="px-4 py-2 bg-obsidian text-bone font-app text-sm font-bold uppercase tracking-wider hover:bg-intl transition-colors">{t("nav.dashboard")}</Link>
            ) : (
              <Link to="/register" className="px-4 py-2 bg-obsidian text-bone font-app text-sm font-bold uppercase tracking-wider hover:bg-intl transition-colors">{t("nav.getScore")}</Link>
            )}
          </div>
        </div>
      </nav>

      <main className="flex-1">
        <header className="max-w-3xl mx-auto px-6 lg:px-12 pt-20 pb-10">
          {eyebrow && <div className="font-mono text-xs uppercase tracking-widest text-muted-foreground">{eyebrow}</div>}
          <h1 className="mt-4 font-marketing text-5xl sm:text-6xl tracking-tight leading-none">{title}</h1>
          {updated && <div className="mt-4 font-mono text-xs text-muted-foreground">{updated}</div>}
        </header>
        <article className="max-w-3xl mx-auto px-6 lg:px-12 pb-24 space-y-8 text-[15px] leading-relaxed text-foreground/90">
          {children}
        </article>
      </main>

      <SiteFooter />
    </div>
  );
}

export function LegalSection({ heading, children }) {
  return (
    <section className="space-y-3">
      {heading && <h2 className="font-app text-xl font-semibold tracking-tight">{heading}</h2>}
      <div className="space-y-3 text-muted-foreground">{children}</div>
    </section>
  );
}
